/**
 * Class mix-in system based on
 * https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Classes#les_mix-ins
 * https://github.com/luruke/bidello/blob/master/index.js
 */

export const appMixin = (superclass = class T {}) =>
  class extends superclass {
    constructor(app, ...args) {
      super(...args);
      this.app = app;
      this.app.state.register(this);
    }

    emit(...args) {
      this.app.state.emit(...args);
    }

    destroy() {
      this.app.state.unregister(this);
    }
  };
